ACC.tooglePassword = {

    _autoload: [
        ['init', document.querySelectorAll('[data-password-hidden]').length > 0],
    ],

    objects: {
        passwordToggle: document.querySelectorAll('[data-password-hidden]'),
    },

    elements: {
        form: '#updatePearsonPasswordForm',
        wrapper: '.text-field__wrapper',
        input: '.c-field-password',
    },

    handleButton(button) {
        const input = ACC.tooglePassword.getInput(button);

        if (input.matches('[class*="c-field-password"]') && (input.value)) {
            input.type = ACC.tooglePassword.setInputType(input.type);

            ACC.tooglePassword.setButtonAttributes(button, input.type);
            ACC.tooglePassword.handleButtonText(button, input.type);
        }
    },

    setInputType(type) {
        return type === 'password' ? 'text' : 'password';
    },

    getInput(element) {
        const wrapperClassName = ACC.tooglePassword.elements.wrapper;

        return element.closest(wrapperClassName).firstElementChild;
    },

    getButton(element) {
        const wrapperClassName = ACC.tooglePassword.elements.wrapper;

        return element.closest(wrapperClassName).lastElementChild;
    },

    bindPasswordButton() {
        ACC.tooglePassword.objects.passwordToggle.forEach((button) => {
            button.addEventListener('click', (event) => {
                ACC.tooglePassword.handleButton(button);
                event.preventDefault();
            });
            button.addEventListener('keyup', (event) => {
                if (event.defaultPrevented) {
                    return;
                }

                switch (event.code) {
                case 'Enter':
                case 'Space':
                    ACC.tooglePassword.handleButton(button);
                    break;
                default:
                    return;
                }

                event.preventDefault();
            });
        });
    },

    disabledIfEmpty() {
        const passwordField = document.querySelectorAll(ACC.tooglePassword.elements.input);

        let passwordToggle;

        if (passwordField) {
            passwordField.forEach((pF) => {
                passwordToggle = ACC.tooglePassword.getButton(pF);
                if (pF.matches(':invalid') || (!pF.value)) {
                    passwordToggle.setAttribute('disabled', 'true');
                } else {
                    passwordToggle.removeAttribute('disabled');
                }

                pF.addEventListener('input', () => {
                    passwordToggle = ACC.tooglePassword.getButton(pF);

                    ACC.tooglePassword.handleButtonDisabledAttributes(passwordToggle, !pF.value);
                });
            });
        }
    },

    setButtonAttributes(button, type) {
        const isPasswordType = type === 'password';
        button.setAttribute('data-password-hidden', isPasswordType);
        button.setAttribute('aria-pressed', !isPasswordType);
    },

    handleButtonText(button, type) {
        const eyeAction = button.querySelector('.eye-action');
        const isPasswordType = type === 'password';
        eyeAction.innerText = isPasswordType ? 'Shows ' : 'Hides ';
    },

    handleButtonDisabledAttributes(button, action) {
        if (!action) {
            button.removeAttribute('disabled');
            button.setAttribute('tabindex', '0');
        } else {
            button.setAttribute('disabled', 'true');
            button.setAttribute('tabindex', '-1');
        }
    },

    init: () => {
        ACC.tooglePassword.bindPasswordButton();
        ACC.tooglePassword.disabledIfEmpty();
    },
};
